export default "__VITE_ASSET__CsQnVWhy__"